const reviews = [
  {
    id: 1,
    name: "Pranay Gupta",
    job: "Software Engineer",
    image:
      "https://aeccc.targettechnology.in/static/media/PranayGupta.f3c530b7630ba8efb2ab.jpg",
    text: "I’ve had the pleasure of working with this team on several projects and am always impressed. Their creativity, attention to detail, and clear communication make every collaboration smooth and effective. I highly recommend them for anyone seeking quality results.",
  },
  {
    id: 2,
    name: "Abir Pal",
    job: "Graphic Designer",
    image:
      "https://aeccc.targettechnology.in/static/media/AbirPal.574a09ad7cb325853b29.jpg",
    text: "I've worked with this company for years and have always been impressed by their creativity and professionalism. They consistently deliver high-quality work, meet deadlines, and bring fresh ideas to every project. It's a pleasure collaborating with such a reliable and innovative team.",
  },
  {
    id: 3,
    name: "Soumya Banerjee",
    job: "Marketing Manager",
    image:
      "https://aeccc.targettechnology.in/static/media/SoumyaBanerjee.2e2521d6029842435080.jpg",
    text: "I am thrilled with the results of our recent marketing campaign, and it wouldn't have been possible without this fantastic team. Their strategic insight, creativity, and dedication made a real difference.Thankyou very much for this opportunity.",
  },
  {
    id: 4,
    name: "Saikat Mukherjee",
    job: "Content Strategist",
    image:
      "https://aeccc.targettechnology.in/static/media/SaikatMukherjee.033310703edff52d0532.jpg",
    text: "I have worked with many content creators over the years, but none have impressed me as much. Their originality, consistency, and deep understanding of the audience truly set them apart. Collaborating with them has been both seamless and inspiring.",
  },
  {
    id: 5,
    name: "Aritra Biswas",
    job: "Data Analyst",
    image: "https://avatars.githubusercontent.com/u/93366359?v=4",
    text: "I had the opportunity to work with this team on a data analysis project, and I was genuinely impressed. Their analytical skills, attention to detail, and clear communication made the entire process smooth and insightful. I would gladly collaborate with them again.",
  },
];

export default reviews;
